// [cleanup 2025-11-18] Removed unused useEffect import
import { useState } from 'react';
import GoogleAd from './GoogleAd';
import { useAdConfig } from '../hooks/useAdConfig';

interface AnchorAdProps {
  slot?: string;
}

/**
 * Sticky bottom banner ad (mobile & desktop)
 * User can close it
 */
export default function AnchorAd({ slot = 'ANCHOR_BOTTOM' }: AnchorAdProps) {
  const { showAdsForCurrentUser } = useAdConfig();
  const [visible, setVisible] = useState(true);

  // Don't render if ads are disabled for this user
  if (!showAdsForCurrentUser || !visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#000',
      borderTop: '1px solid #333',
      zIndex: 9999,
      padding: '8px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
    }}>
      {/* Close button */}
      <button
        onClick={() => setVisible(false)}
        style={{
          position: 'absolute',
          top: '4px',
          right: '4px',
          background: 'rgba(255,255,255,0.1)',
          border: 'none',
          color: '#fff',
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          cursor: 'pointer',
          fontSize: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: '1',
        }}
        aria-label="Reklamı kapat"
      >
        ×
      </button>

      {/* Ad */}
      <GoogleAd 
        slot={slot} 
        format="horizontal"
        style={{ 
          width: '100%',
          maxWidth: '728px',
          height: '90px',
        }}
      />
    </div>
  );
}
